import { opaccAjaxPlugin } from '../opacc.static.js';

/** @module article */

/**
 *  Asynchrones Laden der Lagerverfügbarkeit
 */
export class OpaccStock {
	constructor() {
		this.wrapperElement = document.querySelector('.content');
		this.stockSelector = '.opc-stock';
		this.asyncTemplateSelector = null;
		this.asyncTemplate = this.asyncTemplateSelector ? this.asyncTemplateSelector.dataset.opAsynctemplate : 'async';
		this.jsonToPost = { items: [] };

		this.checkLoadingTypeAndGetStock();
		this.attachEventListener();
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		this.wrapperElement.addEventListener('change', (e) => {
			if (e.target === this.wrapperElement) {
				this.checkLoadingTypeAndGetStock();
			}
		});
	}

	/**
	 *
	 *
	 */
	getAsynStock() {
		let data = { type: 'stock', catitems: JSON.stringify(this.jsonToPost) };
        let url = opaccAjaxPlugin.setAsyncUrl(true);
		this.asyncTemplateSelector = this.wrapperElement.querySelector(this.stockSelector) || null;
		opaccAjaxPlugin.fetchAsynPostForm(url, data, this.getStockFromJsonResult.bind(this), this.getDefaultErrorFnc, true);
		this.jsonToPost = { items: [] };
	}

	/**
	 *
	 *
	 * @param {*} response
	 */
	getStockFromJsonResult(response) {
		if (response.success) {
			response.dataAsJson.items.forEach( val => {
				let htmlItemId = 'data-op-catitemartinternalno';
				let jsonItemId = 'catitemartinternalno';
				if (val.catitemboid) {
					htmlItemId = 'data-op-catitemboid';
					jsonItemId = 'catitemboid';
				}

				let itemSelector = '.opc-stock[data-op-loadingstatus=\'async\']:not(.has-loaded)';
				let htmlElems = this.wrapperElement.querySelectorAll(`${itemSelector}[${htmlItemId}='${val[jsonItemId]}']`) || undefined;

				if (htmlElems.length > 0) {
					Array.from(htmlElems).forEach(htmlElem => {
						let stockObj = htmlElem.querySelector('span.stock-value') || undefined;
						if (+val.loadingtype === 1 || +val.loadingtype === 2) {
							if (val.html) { htmlElem.innerHTML = val.html; }

							// Ampelwerte refresh (CSS Class for Icon & SVG and Text for Value)
							if (val.stockicon) {
								htmlElem.dataset.opStatus = val.stockicon;
								let stockIcon = htmlElem.querySelector('svg');
								let stockIconClass = `op-icon-stock-${val.stockicon}`;
								stockIcon.className.baseVal = stockIconClass;
								stockIcon.querySelector('use').setAttribute('xlink:href', `#${stockIconClass}`);
							}
							if (val.stockvalue) { stockObj.replaceWith(val.stockvalue); }
						}
						// add Styleclass
						htmlElem.classList.add('has-loaded');
					});
				}
			});
		}
	}

	/**
	 *
	 *
	 */
	checkLoadingTypeAndGetStock() {
		let stockElem = this.wrapperElement.querySelector(this.stockSelector) || null;
		let source = stockElem ? +stockElem.dataset.opSource : '';
		let loadingType = stockElem ? +stockElem.dataset.opLoadingtype : '';
		let asyncOp = (source !== 2 && loadingType !== 1) ? '' : 'async';
		if (asyncOp === 'async') {
			let items = this.wrapperElement.querySelectorAll(this.stockSelector);
			Array.from(items).forEach((value) => {
				let item = {};
				if (value.dataset.opCatitemboid) { item.catitemboid = value.dataset.opCatitemboid; }
				if (value.dataset.opCatitemartinternalno) { item.catitemartinternalno = value.dataset.opCatitemartinternalno; }
				if (value.dataset.opSource) { item.source = value.dataset.opSource; }
				if (value.dataset.opStocktype) { item.stocktype = value.dataset.opStocktype; }
				if (value.dataset.opStockloc) { item.stockloc = value.dataset.opStockloc; }
				if (value.dataset.opDispo) { item.dispo = value.dataset.opDispo == 'true' || value.dataset.opDispo == '1' ? 1 : 0; }
				if (value.dataset.opDispodate) { item.dispodate = value.dataset.opDispodate; }
				if (value.dataset.opLoadingtype) { item.loadingtype = value.dataset.opLoadingtype; }
				if (value.dataset.xfas) { item.xfas = value.dataset.xfas; }
				if (value.dataset.opXfas) { item.xfas = value.dataset.opXfas; }
				if (value.dataset.opAsynctemplate) item.template = value.dataset.opAsynctemplate;

				if (this.jsonToPost.items.length > 0) {
					let contains = false;
					this.jsonToPost.items.forEach((itemValue)  => {
						if (item.catitemboid) {
							if (itemValue['catitemboid'] === item.catitemboid) {
								contains = true;
							}
						} else {
							if (itemValue['catitemartinternalno'] === item.catitemartinternalno) {
								contains = true;
							}
						}
					});
					if (!contains) {
						this.jsonToPost.items.push(item);
					}
				} else {
					this.jsonToPost.items.push(item);
				}
			});

			// Unterschied ob Binding automatisch oder interaktiv passiert
			switch (loadingType) {
			case 2:
				stockElem.addEventListener('mouseover', () => {
					this.getAsynStock();
				});
				break;
			default:
				this.getAsynStock();
				break;
			}
		}
	}
}